import i18n from '@/utils/i18n';
import React, { useState } from 'react';
import { ChatInput, Icons } from '@usepepper/sprout-kit-ui';
import { useTheme } from '@/contexts/theme-context';

const SEND_ICON_SIZE = 20;

// Oversized messages stress the BE and can freeze the client (SRG-265 AC);
// the input truncates typing and pastes at this cap.
const MAX_MESSAGE_LENGTH = 2000;

interface CopilotComposerProps {
  onSend: (text: string) => void;
  sending?: boolean;
}

export const CopilotComposer: React.FC<CopilotComposerProps> = ({
  onSend,
  sending,
}) => {
  const theme = useTheme();
  const [value, setValue] = useState('');

  const handleSend = () => {
    const trimmed = value.trim();

    if (trimmed.length === 0) {
      return;
    }

    onSend(trimmed);
    setValue('');
  };

  return (
    <ChatInput
      aria-label={i18n.t('sales_portal.copilot.placeholder')}
      maxLength={MAX_MESSAGE_LENGTH}
      onChangeText={setValue}
      onSend={handleSend}
      placeholder={i18n.t('sales_portal.copilot.placeholder')}
      sendIcon={
        <Icons.ArrowUp
          color={theme.sk.color.icon.ondark}
          size={SEND_ICON_SIZE}
        />
      }
      sending={sending}
      value={value}
    />
  );
};
